export const TABLE_VH = '57vh';
export const TABLE_VH_HIGH = '62vh';
